<template>
  <div>
    <input @input="input" :type="type" :value="value" :required="required" :id="id"
           class="input-base w-full sm:leading-5 rounded-md" :class="$parent.inputClass"
           :placeholder="placeholder"/>
    <div class="absolute block inset-y-0 right-0 pr-3 flex items-center  cursor-pointer">
      <ui-icon-eye-outline v-show="type==='password'" @click="type = 'text'" class="h-5 w-5 text-gray-400"/>
      <ui-icon-eye-off-outline v-show="type==='text'" @click="type = 'password'" class="h-5 w-5 text-gray-400"/>
    </div>
  </div>
</template>

<script>

import {setup, mixin} from "@/components/ui/form/mixins/BaseInput";
import UiIconEyeOutline from "@/components/ui/icons/UiIconEyeOutline";
import UiIconEyeOffOutline from "@/components/ui/icons/UiIconEyeOffOutline";

export default {
  name: "UiFormPassword",
  components: {UiIconEyeOffOutline, UiIconEyeOutline},
  setup: setup,
  mixins: [mixin],
  props: {
    show: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      type: 'password',
    }
  },
  watch: {
    show(val) {
      this.type = val ? 'text' : 'password';
    }
  },
  mounted() {
    this.type = this.show ? 'text' : 'password';
  }
}
</script>